import { Loader2 } from 'lucide-react'
import { cn } from '../../lib/cn.js'

/**
 * Something is happening and there is no shape to draw yet.
 *
 * Prefer a `Skeleton` wherever the shape is known — a spinner says only that the
 * page is busy, and a skeleton says what is arriving. This is for the cases with
 * genuinely nothing to outline: a button mid-press, a panel mid-save.
 */
export function Spinner({ className, label = 'Loading' }: { className?: string; label?: string }) {
  return (
    <span role="status" aria-label={label}>
      <Loader2 className={cn('size-4 animate-spin text-ink-muted', className)} aria-hidden />
    </span>
  )
}
